import { PDP_BADGE_SELECTOR, PDP_QTY_CONTROL_SELECTOR, PDP_QTY_SELECTOR } from './constants';
import { formatEntries, normalizeMultiplier, parseNumber } from './helpers';
import { pulseBadgeForQuantityChange, revealBadge, setBadgeContent } from './render';

const PDP_QTY_BOUND_ATTR = 'data-entries-qty-bound';

function getPdpQuantity() {
    const qtyInput = document.querySelector(PDP_QTY_SELECTOR);

    if (!qtyInput) {
        return 1;
    }

    return Math.max(1, Math.round(parseNumber(qtyInput.value)) || 1);
}

export function processPdpBadge() {
    const badge = document.querySelector(PDP_BADGE_SELECTOR);

    if (!badge) {
        return;
    }

    const price = parseNumber(badge.dataset.entriesPrice);

    if (Number.isNaN(price) || price <= 0) {
        return;
    }

    const multiplier = normalizeMultiplier(parseNumber(badge.dataset.entriesMultiplier));
    let lastRenderedQuantity = null;

    function updateBadge(quantity) {
        const qty = Math.max(1, Math.round(quantity) || 1);
        const perUnitEntries = price * multiplier;
        const totalEntries = price * multiplier * qty;

        setBadgeContent(badge, {
            totalEntries,
            multiplier,
            entriesText: `${formatEntries(totalEntries)} TOTAL ENTRIES`,
            multiplierText: `${formatEntries(perUnitEntries)} x ${qty}`,
        });

        if (lastRenderedQuantity !== null && lastRenderedQuantity !== qty) {
            pulseBadgeForQuantityChange(badge);
        }

        lastRenderedQuantity = qty;
    }

    function updateFromCurrentQuantity() {
        updateBadge(getPdpQuantity());
    }

    updateFromCurrentQuantity();
    revealBadge(badge);

    const qtyInput = document.querySelector(PDP_QTY_SELECTOR);
    const qtyControl = document.querySelector(PDP_QTY_CONTROL_SELECTOR);

    if (qtyInput && !qtyInput.hasAttribute(PDP_QTY_BOUND_ATTR)) {
        const onQtyChange = () => {
            updateFromCurrentQuantity();
        };

        qtyInput.addEventListener('change', onQtyChange);
        qtyInput.addEventListener('input', onQtyChange);
        qtyInput.addEventListener('keyup', onQtyChange);
        qtyInput.setAttribute(PDP_QTY_BOUND_ATTR, 'true');
    }

    if (qtyControl && !qtyControl.hasAttribute(PDP_QTY_BOUND_ATTR)) {
        qtyControl.addEventListener('click', (event) => {
            if (!event.target.closest('button[data-action]')) {
                return;
            }

            requestAnimationFrame(() => {
                updateFromCurrentQuantity();
            });
        });

        qtyControl.setAttribute(PDP_QTY_BOUND_ATTR, 'true');
    }
}
